'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_DISCIPLINES_REQUEST: 'FETCH_DISCIPLINES_REQUEST',
    FETCH_DISCIPLINES_SUCCEEDED: 'FETCH_DISCIPLINES_SUCCEEDED',
    FETCH_DISCIPLINES_FAILED: 'FETCH_DISCIPLINES_FAILED'
};

function fetchDisciplinesRequest() {
    return {
        type: actionTypes.FETCH_DISCIPLINES_REQUEST
    };
}

function fetchDisciplinesSucceeded(disciplines) {
    return {
        type: actionTypes.FETCH_DISCIPLINES_SUCCEEDED,
        disciplines: disciplines
    };
}

function fetchDisciplinesFailed() {
    return {
        type: actionTypes.FETCH_DISCIPLINES_FAILED
    };
}

var actionCreators = {
    fetchDisciplinesRequest: fetchDisciplinesRequest,
    fetchDisciplinesSucceeded: fetchDisciplinesSucceeded,
    fetchDisciplinesFailed: fetchDisciplinesFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/disciplines.js
// module id = 56
// module chunks = 0